import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Work out where the visitor came from: UTM link first, then the referring site.
function detectSource() {
  try {
    const utm = (new URLSearchParams(window.location.search).get("utm_source") || "").toLowerCase().trim();
    if (utm) return utm.charAt(0).toUpperCase() + utm.slice(1);
    if (!document.referrer) return "Direct";
    const host = new URL(document.referrer).hostname.toLowerCase();
    if (host.includes("facebook") || host.includes("fb.")) return "Facebook";
    if (host.includes("instagram")) return "Instagram";
    if (host.includes("google")) return "Google";
    if (host.includes("wa.me") || host.includes("whatsapp")) return "WhatsApp";
    if (host.includes("t.co") || host.includes("twitter") || host.includes("x.com")) return "X";
    if (host.includes("linkedin")) return "LinkedIn";
    if (host.includes("bing")) return "Bing";
    return host;
  } catch {
    return "Direct";
  }
}

export function getSource() {
  let s = sessionStorage.getItem("ea_source");
  if (!s) {
    s = detectSource();
    sessionStorage.setItem("ea_source", s);
  }
  return s;
}

// fire-and-forget event tracking — never blocks or breaks the UI
export function track(event, meta = "") {
  try {
    axios
      .post(
        `${API}/track`,
        { event, page: window.location.pathname + window.location.hash, meta, source: getSource() },
        { timeout: 5000 }
      )
      .catch(() => {});
  } catch {
    /* ignore */
  }
}
